<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/establish/contractlist',title:'返利管理'},{title:'客户履约统计'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content w-content">
            <!--查询表单-->
            <div class="h-piece">
                <div class="h-formBox">
                    <!-- <div class="h-pieceTitle2" style="margin-bottom:0.2rem">
                        <h1>客户履约统计</h1>
                    </div> -->
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="累计类型" prop="styles">
							    <el-select v-model="q.type" placeholder="请选择">
							        <el-option
							                v-for="item in fljsstyle"
							                :key="item.value"
							                :label="item.label"
							                :value="item.value">
							        </el-option>
							    </el-select>
							</el-form-item>
							<el-form-item label="时间" class="nianboxs" v-if="check1">
							    <el-date-picker
										style="width: 100%;"
							            v-model="q.date"
							            :clearable="true"
							            type="month"
							            value-format="yyyy-MM"
							            placeholder="选择日期">
							    </el-date-picker>
							</el-form-item>
							<el-form-item label="产品类型" class="nianboxs">
								<el-select v-model="q.rebateChainGroup" placeholder="请选择">
									<el-option
											v-for="item in options1"
											:key="item.code"
											:label="item.name"
											:value="item.code">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="区域" prop="area" v-auth="'lytjXs_quyu'">
							    <el-select v-model="q.area" placeholder="请选择">
									<el-option
											v-for="item in options2"
											:key="item.code"
											:label="item.name"
											:value="item.code">
									</el-option>
							    </el-select>
							</el-form-item>
						</div>	
                        
						<div class="h-formBtnOut h-columnCenter">
						    <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
						    <el-button class="h-btn h-formBtn h-bgwhite" @click="qingkong">重置</el-button>
						</div>
                    </el-form>
                </div>
            </div>


            <!--展示表格-->
            <div class="h-table h-mrt30">
                <el-table @selection-change="handleSelectionChange"
                          ref="ddtable"
                          :data="tableData"
                          stripe
                          style="width: 100%"
                          :summary-method="getSummaries"
                          show-summary
                          :border="true"
						  max-height="500"

                >
                    <el-table-column
                            type="selection"
                            width="50"
                    >
                    </el-table-column>
                    <el-table-column
                            type="index"
                            label="#"
                            width="40">
                    </el-table-column>
                    <el-table-column
                            prop="area"
							width="80"
                            :show-overflow-tooltip="true"
                            label="区域"
                    >
                        <template slot-scope="scope">
                            <dictname category="YLRegion" :v="scope.row.area"/>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="qianyueCount"
                            :show-overflow-tooltip="true"
                            label="签约客户数量"
							width="120"
                    >
						<template slot-scope="scope">
						    <div style="text-align: right;">{{scope.row.qianyueCount}}</div>
						</template>
                    </el-table-column>
                    <el-table-column label="0履约" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="sla"
                                :show-overflow-tooltip="true"
                                label="数量"
                        >
							<template slot-scope="scope">
							    <div style="text-align: right;">{{scope.row.sla}}</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                prop="zba"
                                :show-overflow-tooltip="true"
                                label="占比"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{new big(Number(scope.row.zba).toFixed(0)) + '%'}}</div>
						</template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="0＜履约率＜50%" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="slb"
                                :show-overflow-tooltip="true"
                                label="数量"
                        >
							<template slot-scope="scope">
							    <div style="text-align: right;">{{scope.row.slb}}</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                prop="zbb"
                                :show-overflow-tooltip="true"
                                label="占比"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{new big(Number(scope.row.zbb).toFixed(0)) + '%'}}</div>
						</template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="50%≤履约率＜70%" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="slc"
                                :show-overflow-tooltip="true"
                                label="数量"
                        >
							<template slot-scope="scope">
							    <div style="text-align: right;">{{scope.row.slc}}</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                prop="zbc"
                                :show-overflow-tooltip="true"
                                label="占比"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{new big(Number(scope.row.zbc).toFixed(0)) + '%'}}</div>
						</template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="70%≤履约率＜100%" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="sld"
                                :show-overflow-tooltip="true"
                                label="数量"
                        >
							<template slot-scope="scope">
							    <div style="text-align: right;">{{scope.row.sld}}</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                prop="zbd"
                                :show-overflow-tooltip="true"
                                label="占比"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{new big(Number(scope.row.zbd).toFixed(0)) + '%'}}</div>
						</template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="履约率≥100%" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="sle"
                                :show-overflow-tooltip="true"
                                label="数量"
                        >
							<template slot-scope="scope">
							    <div style="text-align: right;">{{scope.row.sle}}</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                prop="zbe"
                                :show-overflow-tooltip="true"
                                label="占比"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{new big(Number(scope.row.zbe).toFixed(0)) + '%'}}</div>
						</template>
                        </el-table-column>
                    </el-table-column>
                </el-table>
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                   @click="exportExcel" v-auth="'khlytj_daochu'">批量导出
                        </el-button>
                    </div>
                    <!--<div class="h-pagination2">-->
                        <!--<pagination :page="q" @query="query"/>-->
                    <!--</div>-->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'

    export default {
        components: {},
        data() {
            return {
                check1:true,
                fljsstyle: [
                    {
                        value: 1,
                        label: '年累计'
                    },
                    {
                        value: 2,
                        label: '月累计'
                    },
                ],
                value2:'',
                showhistory:false,
                instid: '',
                taskid:'',
                //查询属性
                page:{
                    contractBaseId:'',
                },
                q: {
                    taskid:'',
                    pageSize: 10,
                    rebateChainGroup:null,
                    date: null,
                    type:null,
                },
                //表单
                f:{
                    code:null, //
                    qianyueCount:null, //
                    area:null,
                    sla:null,
                    zba:null, //
                    slb:null, //
                    zbb:null, //
                    slc:null,
                    zbc:null,
                    sld:null, //
                    zbd:null, //
                    sle:null, //
                    zbe:null,
                },
                //表格
                multipleSelection: [],

                //table列表
                tableData: [],
                options1:[],
                options2:[],
                flag:0,
                //操作标志
                optflag:'save',
            }
        },
        created() {
            this.queryb();
			this.q = {
				taskid:'',
				pageSize: 10,
				date: this.doHandleDate(),
				type:2,
				rebateChainGroup:'zhj'
			}
            this.query();
        },
        methods: {

			
			doHandleDate() {
			    var myDate = new Date();
			    var tYear = myDate.getFullYear();
			    var tMonth = myDate.getMonth();
			 
			    var m = tMonth + 1;
			    if (m.toString().length == 1) {
			        m = "0" + m;
			    }
			    return tYear +'-'+ m;
			},

            //重置
            qingkong(){
                this.qijianLike=null,

                    this.q = {
                        styles: '',
                        taskid:'',
                        agentNameLike:'',
                        agentCodeLike:'',
                        pageSize: 10,
                        pageNo: 1,
                        total: 0,
                        rebateChainGroup:'zhj',
                        type:2,
                        date :this.doHandleDate(),

                    }
                this.query();
            },
            query() {
                ss.fanli.pagecustomerLyTongji(this.q).then(rd=>{
                    // console.log(rd,"BBBBBB");
                    this.q.total = rd.total;
					var rds = rd.records;
					for(var i=0;i<rds.length;i++){
						 rds[i].zba = (rds[i].zba).slice(0,(rds[i].zba).length-1)
						 rds[i].zbb = (rds[i].zbb).slice(0,(rds[i].zbb).length-1)
						 rds[i].zbc = (rds[i].zbc).slice(0,(rds[i].zbc).length-1)
						 rds[i].zbd = (rds[i].zbd).slice(0,(rds[i].zbd).length-1)
						 rds[i].zbe = (rds[i].zbe).slice(0,(rds[i].zbe).length-1)

					}
                    this.tableData = rds;
                });

            },
            queryb() {
                ss.fanli.pageQuanxian(this.q).then(rd=>{
                    console.log(rd,"AAAABBBBBB");
                    this.options1 = rd.list;
                    this.options2 = rd.list1;
                });

            },

            getSummaries(param){
				console.log(param)
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    // console.log(column,index)
                    if (index === 0) {
                        sums[index] = '总计';
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
						sums[13] = (sums[12]/ sums[3] * 100).toFixed(0)+"%";
						sums[5] = (sums[4]/ sums[3] * 100).toFixed(0)+"%";
						sums[7] = (sums[6]/ sums[3] * 100).toFixed(0)+"%";
						sums[9] = (sums[8]/ sums[3] * 100).toFixed(0)+"%";
						sums[11] = (sums[10]/ sums[3] * 100).toFixed(0)+"%";
                    } else {
                        sums[1] = '';
                        sums[2] = '';
                        
                    }
                });

                return sums;
            },
            handleFilter() {
                // console.log("11111"+this.q.type)
                // console.log("2222"+this.q.rebateChainGroup)
                // console.log("3333"+this.q.date)

                this.query();
            },
            //勾选
            handleSelectionChange(val) {
                this.multipleSelection = val;
                // console.log(this.multipleSelection,"WWWWWWWWWW")
            },
            //开票明细批量导出
            exportExcel() {
                var idlist = [];
                this.multipleSelection.forEach(element => {
                    // console.log(this.q.type+"@@@@@@@@");
                    idlist.push(element.area+","+this.q.type+","+this.q.rebateChainGroup+","+this.q.date);
                    // console.log(idlist);
                });
                if (idlist.length != 0) {
                    // console.log(idlist);
                    updownfile.down("/api/swyl/v1/demo/viewLvyueTable/downloadExcelAreaDetail", idlist, "post", 'data');
                } else {
                    updownfile.down("/api/swyl/v1/demo/viewLvyueTable/downloadExcelAreaEntity", this.q, "post");
                }

            },
        }
    }
</script>
<style>
    .el-table thead.is-group th{
        background-color: #57aefe;
    }
	.w-content .el-table__footer-wrapper .cell {
		text-align: right;
	}
	.w-content .el-table__fixed-footer-wrapper tbody td {
		background: #cce7ff;
	}
	.w-content .el-table__footer-wrapper tbody td {
		background: #cce7ff;
	}
</style>